import type * as monacoEditor from 'monaco-editor';

export enum PromptLanguage {
  PLAIN_TEXT = 'plaintext',
  MASKING = 'masking_prompt_lang',
  RERANK = 'rerank_prompt_lang',
  RESPONSE_GENERATION = 'response_generation_prompt_lang',
  PARAPHRASING = 'paraphrasing_prompt_lang',
  ROUTING = 'routing_prompt_lang',
  SPLITTING = 'splitting_prompt_lang',
  CHAT_HISTORY_SUMMARIZATION = 'chat_history_summarization_prompt_lang',
}

export const PROMPT_LANGUAGE_THEME_ID = 'promptLangTheme';
export const VARIABLE_HIGHLIGHT_COLOR = 'EB700B'; // @orange-orange-600
export const VARIABLE_TOKEN_ID = 'bracketToken';

export const PROMPT_LANGUAGE_THEME: monacoEditor.editor.IStandaloneThemeData = {
  base: 'vs',
  inherit: true,
  rules: [{ token: VARIABLE_TOKEN_ID, foreground: VARIABLE_HIGHLIGHT_COLOR, fontStyle: 'bold' }],
  colors: {},
};

export const MONACO_EDITOR_OPTIONS: monacoEditor.editor.IStandaloneEditorConstructionOptions = {
  lineNumbers: 'off',
  glyphMargin: false,
  folding: false,
  lineDecorationsWidth: 0,
  lineNumbersMinChars: 0,
  showFoldingControls: 'mouseover',
  minimap: { enabled: false },
  wordWrap: 'on',
  scrollBeyondLastLine: false,
  wordBasedSuggestions: false,
  padding: { top: 4, bottom: 4 }, // NOTE: for better fit inside parent's border; can't be fully achieved with styles.
};
